import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import Modal from '../../Modal/Modal';
import Heading from '../../Typography/Heading/Heading';
import styles from './MakeOwnerModal.module.scss';
import { useTranslation } from 'react-i18next';
import { Field, Form, Formik } from 'formik';
import SelectInput from '../../Form/SelectInput/SelectInput';
import { makeNewOwner } from '../../../store/reducers/Guild/guildRequest';
import Button from '../../Button/Button';
import cn from 'classnames';
import Loader from '../../Loader/Loader';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { useNavigate } from 'react-router-dom';
import Paragraph from '../../Typography/Paragraph/Paragraph';
import { GuildActionsName, MembersType } from '../../../store/reducers/Guild/guildType';
import { clearData } from '../../../store/reducers/Guild/slice';
import TextError from '../../TextError/TextError';
import { firstLetterUpperCase } from '../../../helpers';
import { displayName } from '../../LabelBox/LabelBox';
const MakeOwnerModal = ({ membersList, closeModal, id }) => {
    const { t } = useTranslation();
    const { pending, error, isDataSent, errorLeaveGuild } = useAppSelector((state) => state.guild);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const parsedMemberList = membersList
        .filter(({ type }) => MembersType.OWNER !== type)
        .map((member) => ({
        value: member.member.id,
        label: displayName((member === null || member === void 0 ? void 0 : member.member.name) || '', (member === null || member === void 0 ? void 0 : member.member.address) || '')
    }));
    useEffect(() => {
        if (!error && isDataSent.includes(GuildActionsName.MAKE_OWNER)) {
            closeModal();
            navigate('/social/all-guilds');
            dispatch(clearData(GuildActionsName.MAKE_OWNER));
        }
    }, [error, dispatch, closeModal, isDataSent, navigate]);
    return (_jsxs(Modal, Object.assign({ className: styles.element, background: true, closeModal: closeModal }, { children: [_jsx(Heading, { className: styles.heading, title: t('are_you_sure_to_want_to_leave_guild') }), _jsx(Paragraph, { fontFamily: 'urbanist', className: styles.text, color: 'grey', title: t('before_you_leave_choose_someone_who_will_be_an_admin') }), _jsx(Formik, Object.assign({ initialValues: {
                    id: ''
                }, onSubmit: (values) => {
                    if (id) {
                        dispatch(makeNewOwner({ guildId: id, nextOwnerId: values.id }));
                    }
                } }, { children: ({ setFieldValue, values, handleSubmit }) => (_jsxs(Form, Object.assign({ onSubmit: handleSubmit }, { children: [_jsx(Field, { type: "text", name: "members", value: values.id, onChange: (e) => {
                                setFieldValue('id', e.value);
                            }, className: styles.select, placeholder: t('choose_member'), options: parsedMemberList, component: SelectInput }), _jsxs("div", Object.assign({ className: cn(styles.box, 'd-flex align-items-center justify-content-between') }, { children: [pending.includes(GuildActionsName.MAKE_OWNER) ? (_jsx(Button, { className: cn('w-100'), height: 'sm', size: 'auto', type: 'submit', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx(Button, { className: cn(styles.button, 'w-100'), height: 'sm', size: 'auto', type: 'submit', text: t('save_and_leave') })), _jsx(Button, { onClick: closeModal, size: 'auto', height: 'sm', color: 2, text: t('cancel') })] }))] }))) })), errorLeaveGuild && (_jsx(TextError, { className: styles.errorText, text: firstLetterUpperCase(errorLeaveGuild) }))] })));
};
export default MakeOwnerModal;
